import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../Onboarding.module.scss";
import Button from "../../../common/components/Button";

const EmailOnboard = (props) => {
  const { onNextStep, setEmail, email } = props;

  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <h2>{t("onboard.welcome")}</h2>
      </div>

      <form onSubmit={(e) => onNextStep(e, email)}>
        <div className={styles.inputContainer}>
          <label htmlFor="email">{t("sign_in.email")}</label>
          <input
            value={email}
            onChange={(e) => {
              const email = e.target.value;
              setEmail(email);
            }}
            autoComplete="username"
            placeholder={t("sign_in.email")}
            id="email"
            name="email"
            type="email"
            autoFocus
            required
          />
        </div>
        <div className={styles.actionContainer}>
          <Button type="submit">{t("sign_in.continue")}</Button>
        </div>
      </form>
    </div>
  );
};

export default EmailOnboard;
